import React from "react";

import { Check } from "lucide-react";

import { completedDashedIcon, inCompletedDashedIcon } from "./icons";

type IntegrationFooterProps = {
    integrationType: string;
    currentStep: number;
};

const STEPS = [
    { number: 0, label: "Login" },
    { number: 1, label: "Configure" },
    { number: 2, label: "Finish" },
];

export const IntegrationFooter = ({
    integrationType,
    currentStep,
}: IntegrationFooterProps) => {
    return (
        <footer className="w-full px-4 py-3 flex justify-center items-center mt-auto border-t border-t-[#F1F2F4] rounded-b-[8px] ">
            <div className="flex items-center gap-2">
                {STEPS.map((step) => (
                    <div
                        key={step.number}
                        className={`flex items-center gap-2 `}
                    >
                        <span
                            className={`size-[20px] rounded-full flex items-center text-xs justify-center  font-medium ${
                                step.number === currentStep ||
                                step.number < currentStep
                                    ? "bg-blue-500 text-white"
                                    : " bg-white border border-[#8590A2] text-[#8590A2]"
                            }`}
                        >
                            {step.number === currentStep ||
                            step.number < currentStep ? (
                                <Check size={12} />
                            ) : (
                                step.number + 1
                            )}
                        </span>
                        <span
                            className={`text-sm ${
                                step.number === currentStep ||
                                step.number < currentStep
                                    ? "text-blue-500 font-semibold"
                                    : "text-gray-500"
                            } `}
                        >
                            {step.label}
                        </span>
                        {/* Dashed line */}
                        {step.number < STEPS.length - 1 &&
                            (step.number === currentStep ||
                            step.number < currentStep
                                ? inCompletedDashedIcon
                                : completedDashedIcon)}
                    </div>
                ))}
            </div>
        </footer>
    );
};
